export const JUTE_ISSUE_LIST = "jute_issue_list";
export const JUTE_ISSUE_LIST_SUCCESSFULL = "jute_issue_list_successfull";
export const JUTE_ISSUE_LINE_ITEMS = "jute_gate_entry_line_items";
export const JUTE_ISSUE_CREATE = "jute_gate_entry_create";
export const JUTE_ISSUE_VIEW_BY_ID = "jute_gate_entry_view_by_id";
export const JUTE_ISSUE_VIEW_BY_ID_SCCESSFULL = "jute_gate_entry_view_by_id_successfull";
